import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryV2 } from './api';

interface IPartnerReferral {
  created_at: string;
  email_masked: string;
  full_name: string;
  reward: number;
  plan_name: string;
}

interface IPartnerReferralList {
  data: IPartnerReferral[];
}

export const partnersApi = createApi({
  reducerPath: 'partnersApi',
  baseQuery: baseQueryV2,
  tagTypes: ['Partners'],
  endpoints: (build) => ({
    getPartnerReferrals: build.query<IPartnerReferralList, void>({
      query: () => ({
        url: '/referrals-partner',
        method: 'POST',
        body: {},
      }),
      providesTags: ['Partners'],
    }),
  }),
});

export const { useGetPartnerReferralsQuery } = partnersApi;
